export function calculateTax(income, regime) {
  let tax = 0;

  // ---------------------------
  // OLD REGIME (FY 2025-26)
  // ---------------------------
  if (regime === "old") {
    if (income <= 250000) tax = 0;

    else if (income <= 500000)
      tax = (income - 250000) * 0.05;

    else if (income <= 1000000)
      tax = 12500 + (income - 500000) * 0.2;

    else
      tax = 112500 + (income - 1000000) * 0.3;
  }

  // ---------------------------
  // NEW REGIME (FY 2025-26)
  // ---------------------------
  else if (regime === "new") {
    // 👉 Standard deduction (salaried)
    const standardDeduction = 75000;
    let taxable = Math.max(income - standardDeduction, 0);

    if (taxable <= 400000) tax = 0;

    else if (taxable <= 800000)
      tax = (taxable - 400000) * 0.05;

    else if (taxable <= 1200000)
      tax = 20000 + (taxable - 800000) * 0.1;

    else if (taxable <= 1600000)
      tax = 60000 + (taxable - 1200000) * 0.15;

    else if (taxable <= 2000000)
      tax = 120000 + (taxable - 1600000) * 0.2;

    else if (taxable <= 2400000)
      tax = 200000 + (taxable - 2000000) * 0.25;

    else
      tax = 300000 + (taxable - 2400000) * 0.3;

    // ---------------------------
    // REBATE (IMPORTANT REAL RULE)
    // ---------------------------
    // If taxable income ≤ 7 lakh → tax becomes 0
    if (taxable <= 700000) {
      tax = 0;
    }
  }

  // ---------------------------
  // CESS (BOTH REGIMES)
  // ---------------------------
  tax += tax * 0.04;

  return {
    tax: Math.round(tax),
    net: income - tax,
  };
}